import { render, staticRenderFns } from "./AssetMessage.vue?vue&type=template&id=0ee0b965&scoped=true"
import script from "./AssetMessage.vue?vue&type=script&lang=js"
export * from "./AssetMessage.vue?vue&type=script&lang=js"
import style0 from "./AssetMessage.vue?vue&type=style&index=0&id=0ee0b965&prod&lang=scss&scoped=true"
import style1 from "./AssetMessage.vue?vue&type=style&index=1&id=0ee0b965&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee0b965",
  null
  
)

export default component.exports